<template>
  <div>
    <el-form ref="searchForm" :model="searchForm" :inline="true" :label-position="position">
      <el-form-item>
        <el-input v-model="searchForm.name" placeholder="应用名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.mainVersion" placeholder="主版本号" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.version" placeholder="版本号" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.buildCode" placeholder="构建号" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.state" placeholder="是否上线" clearable>
          <el-option label="上线" value="1"></el-option>
          <el-option label="未上线" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleQuery">查询</el-button>
        <el-button type="success" @click="handleAdd">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="tableData" border style="width: 100%"  v-loading="loading">
      <el-table-column prop="name" label="应用名称"></el-table-column>
      <el-table-column prop="mainVersion" label="主版本号"></el-table-column>
      <el-table-column prop="version" label="版本号"></el-table-column>
      <el-table-column prop="buildCode" label="构建号"></el-table-column>
      <el-table-column prop="state" label="是否上线">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.state == 1" type="success">上线</el-tag>
          <el-tag v-else type="danger">未上线</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="memo" label="备注"></el-table-column>
      <el-table-column prop="created" label="创建时间"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
     <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.pageNum"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    >
    </el-pagination>
    <el-dialog
      title="详情信息"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      >
      <el-form
        ref="formRef"
        :model="modelInfo"
        style="width:100%"
        :label-position="'right'"
        :inline="true"
        :rules="formRules"
        v-loading="formLoading"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item  label="应用名称" prop="name">
              <el-input v-model="modelInfo.name" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item  label="主版本号" prop="mainVersion">
              <el-input v-model="modelInfo.mainVersion" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item  label="版本号" prop="version">
              <el-input v-model="modelInfo.version" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item  label="构建号" prop="buildCode">
              <el-input v-model="modelInfo.buildCode" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item  label="wgt地址" prop="wgtUrl">
              <el-input v-model="modelInfo.wgtUrl" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item  label="pkg地址" prop="pkgUrl">
              <el-input v-model="modelInfo.pkgUrl" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item  label="是否上线" prop="state">
              <el-select v-model="modelInfo.state" placeholder="是否上线" clearable>
                <el-option label="上线" :value="1"></el-option>
                <el-option label="未上线" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="memo">
              <el-input type="textarea" v-model="modelInfo.memo" placeholder="备注" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" id="recovery-shop-apk-version-upload">
            <el-form-item label="文件上传">
              <el-upload
                class="avatar-uploader fl"
                :data="postData"
                :accept="acceptImage"
                action="https://up.qiniup.com"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload"
              >
              <i class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <span>{{ fileUrl }}</span>
          </el-form-item>
        </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSave">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { genUpToken } from "../basicSetting/com/qiniuToken.js";
import { recoveryShopApkVersionQuery,recoveryShopApkVersionSave,recoveryShopApkVersionUpdate,recoveryShopApkVersionDelete} from '../../api/api';
export default {
  data() {
    return {
      postData: { token: "" },
      qiniuaddr: "pic.allscs.cn", // 这是七牛云空间的外链默认域名
      // 仅支持apk, wgt, pkg格式
      acceptImage: ".apk,.wgt,.pkg",
      fileUrl: "",

      position: "left",
      searchForm: {
        name: "",
        mainVersion: "",
        version: "",
        buildCode:"",
        state: "",
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      loading: false,
      tableData: [],

      dialogVisible: false,
      formLoading: false,
      modelInfo: {
        state: 1
      },
      formRules: {
        name: [
          { required: true, message: "请输入应用名称", trigger: "blur" }
        ],
        mainVersion: [{ required: true, message: "请输入主版本", trigger: "blur" }],
        version: [
          { required: true, message: "请输入版本", trigger: "blur" }
        ],
        buildCode: [
          { required: true, message: "请输入构建版本", trigger: "blur" }
        ],
      }
    }
  },
  created() {
  },
  mounted() {
    this.onload();
  },
  methods: {
    createQiniuToken(filename) {
        var token = "";
        var policy = {};
        var bucket = `hohofast`;
        var AK = "VYiFElH26Am5EbV9T3nACEfNt6xBRz6gEREDFlis";
        var SK = "sFELHoXSwB8NpiWpPj2Wk7theJCO7Iil-2rwSj31";
        var deadline = Math.round(new Date().getTime() / 1000) + 3600;
        policy.scope = bucket;
        policy.saveKey = filename;
        policy.insertOnly=0;
        policy.deadline = deadline;
          token = genUpToken(AK, SK, policy);
        return token;
    },
    handleQuery() {
      this.searchForm.pageNum = 1;
      this.onload();
    },
    handleAdd() {
      this.dialogVisible = true;
      this.modelInfo = {
        state: 1
      }
    },
    async onload() {
      this.loading = true;
      const res = await recoveryShopApkVersionQuery(this.searchForm).finally(() => {
        this.loading = false;
      });
      console.log(res);
      if (res.data.status == 100) {
        this.tableData = res.data.results.list
        this.searchForm.total = res.data.results.total;
      } else {
        this.$message.error(res.data.message);
      }
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.onload();
    },
    handleCurrentChange(page) {
      this.searchForm.pageNum = page;
      this.onload();
    },
    handleAvatarSuccess(res, file) {
      console.log(res);
      console.log(file);
      // this.fileUrl = "http://" + this.qiniuaddr + "/" + res.key + "?imageslim";
      this.fileUrl=`https://${this.qiniuaddr}/${res.key}`
    },
    beforeAvatarUpload(file) {
      //仅支持apk, wgt, pkg格式
      this.postData.token = this.createQiniuToken(file.name);
      return true
    },
    handleEdit(row) {
      this.dialogVisible = true;
      this.modelInfo = row;
    },
    handleSave() {
      this.$refs.formRef.validate(async valid => {
        if (valid) {
          if (this.modelInfo.id) {
            this.formUpdate();
          } else {
            this.formSave();
          }
        }
      });
    },
    async formSave() {
      this.formLoading = true;
      const res= await recoveryShopApkVersionSave(this.modelInfo).finally(() => {
        this.formLoading = false;
      });
      if (res.data.status == 100) {
        this.dialogVisible = false;
        this.onload();
      } else {
        this.$message.error(res.data.message);
      }
    },
    async formUpdate() {
      this.formLoading = true;
      const res = await recoveryShopApkVersionUpdate(this.modelInfo).finally(() => {
        this.formLoading = false;
      });
      if (res.data.status == 100) {
        this.dialogVisible = false;
        this.onload();
      } else {
        this.$message.error(res.data.message);
      }
    },
    async handleDelete(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await recoveryShopApkVersionDelete({id:row.id});
          if (res.data.status == 100) {
            this.onload();
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(() => {
        });
    }
  }
}
</script>
<style scoped>
#recovery-shop-apk-version-upload{
  .avatar-uploader {
    width: 180px;
    height: 180px;
    margin-right: 20px;
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px !important;
    text-align: center;
  }
  .avatar {
    width: 400px;
    height: 178px;
    display: block;
  }
}

</style>



// WEBPACK FOOTER //
// recoveryShopApkVersion.vue?452e36b5